import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c5fb157"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no-active",
  src: "/assets/tabIcon/home.png",
  srcset: "/assets/tabIcon/home@2x.png 2x,/assets/tabIcon/home@3x.png 3x"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "active",
  src: "/assets/tabIcon/home-active.png",
  srcset: "/assets/tabIcon/home-active@2x.png 2x,/assets/tabIcon/home-active@3x.png 3x"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no-active",
  src: "/assets/tabIcon/trending-up.png",
  srcset: "/assets/tabIcon/trending-up@2x.png 2x,/assets/tabIcon/trending-up@3x.png 3x"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "active",
  src: "/assets/tabIcon/trending-up-active.png",
  srcset: "/assets/tabIcon/trending-up-active@2x.png 2x,/assets/tabIcon/trending-up-active@3x.png 3x"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no-active",
  src: "/assets/tabIcon/community.png",
  srcset: "/assets/tabIcon/community@2x.png 2x,/assets/tabIcon/community@3x.png 3x"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "active",
  src: "/assets/tabIcon/community-active.png",
  srcset: "/assets/tabIcon/community-active@2x.png 2x,/assets/tabIcon/community-active@3x.png 3x"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no-active",
  src: "/assets/tabIcon/my-property.png",
  srcset: "/assets/tabIcon/my-property@2x.png 2x,/assets/tabIcon/my-property@3x.png 3x"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "active",
  src: "/assets/tabIcon/my-property-active.png",
  srcset: "/assets/tabIcon/my-property-active@2x.png 2x,/assets/tabIcon/my-property-active@3x.png 3x"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")!
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_tabs, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_tab_bar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_tab_button, {
                class: "home",
                tab: "home",
                href: "/tabs/home",
                "data-dd-action-name": "tab_home",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$clickTrackEvent({clickScreen: $setup.clickScreen, 'clickArea':'하단탭', 'clickContent':'홈'})))
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                class: "search",
                tab: "company",
                href: "/tabs/company",
                "data-dd-action-name": "tab_search",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$clickTrackEvent({clickScreen: $setup.clickScreen, 'clickArea':'하단탭', 'clickContent':'검색'})))
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                class: "community",
                tab: "add",
                href: "/tabs/community",
                "data-dd-action-name": "tab_discussion",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$clickTrackEvent({clickScreen: $setup.clickScreen, 'clickArea':'하단탭', 'clickContent':'성장성토론'})))
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                class: "my-property",
                tab: "myProperty",
                href: "/tabs/mypage/",
                "data-dd-action-name": "tab_my",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$clickTrackEvent({clickScreen: $setup.clickScreen, 'clickArea':'하단탭', 'clickContent':'MY'})))
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}